import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  private http = inject(HttpClient);

  private API_PATH = '/services/pub/api/v1/sharing';
  private API_V2 = '/api/v2/';

  public getUserInfos = async (slugs, emails) => {
    return this.http.post<Array<any>>(`${this.API_PATH}/getUserInfos`, { slugs: slugs, emails: emails }).toPromise();
  };

  public getUsers(slugs, emails) {
    return this.http.post<Array<any>>(`${this.API_PATH}/getUserInfos`, { slugs: slugs, emails: emails });
  }

  private shareMap = (actions) =>
    actions.map((action) => ({
      action: action.action,
      share: { slug: action.share.slug, canWrite: action.share.canWrite, canShare: action.share.canShare },
    }));

  public changeShares = async (contentSlug: string, actions: any) => {
    const res = await this.http
      .patch<any>(this.API_V2 + 'content/' + contentSlug + '/shares', {
        payload: this.shareMap(actions),
      })
      .toPromise();

    return res;
  };

  public getSharedWithMeUsers = async () => {
    return this.http.get(`${this.API_PATH}/sharedWithMeUsers`).toPromise();
  };
}
